import { PageGreetingLocale } from '@/helpers/entities/enums/v2/PageGreetingLocale';
export class PageGreetingModel {
    constructor(payload) {
        this.uuid = payload.uuid;
        this.greetings = payload.jsonData.greeting;
    }
    get default() {
        const greeting = this.greetings.find((g) => {
            return g.locale === PageGreetingLocale.Default;
        });
        return greeting || this.greetings[0];
    }
}
